<ng-container>
	<div
		class="md:flex-none md:w-44 grid grid-cols-3 md:grid-cols-1 gap-6 break-word"
	>
		<div class="md:hidden">
			{{ controller.i18n + '.date.text' | translate }}
		</div>
		<div class="col-span-2 md:justify-self-start justify-self-end">
			{{ task.dueDate | userDate: 'LL' | async }}
		</div>
	</div>
	<div class="md:flex-1 grid grid-cols-3 md:grid-cols-1 md:gap-6 gap-10">
		<div class="md:hidden">
			{{ controller.i18n + '.description.text' | translate }}
		</div>
		<div
			class="
				col-span-2
				md:flex md:flex-wrap md:text-left
				text-justify
				md:justify-self-start
				justify-self-end
			"
		>
			<span
				[innerHTML]="
					task.description
						| translate
							: {
									jobOffer: (task.jobOffer$ | async),
									participantsName:
										$any(task.participants$ | async)
										| usersName: (controller.coacheeId$ | async),
									contact: task.contact$ | async,
									modulesName: (task.modulesName$ | async),
									date: (task.dueDate | userDate: 'LT' | async)
							  }
				"
				class="whitespace-pre-line"
			></span>
			<div
				*ngIf="$any(task.modulesData$ | async) | nullIfEmpty; let modulesData"
				class="flex md:flex-row md:space-y-0 flex-col space-y-1 flex-wrap"
			>
				<span *ngFor="let moduleData of modulesData; let last = last">
					<a
						[routerLink]="[
							'/activity',
							moduleData.id,
							'user',
							controller.coacheeId$ | async
						]"
						class="font-bold whitespace-pre-line"
					>
						{{ moduleData.name }}
					</a>
					<ng-container *ngIf="!last">,&nbsp;</ng-container>
				</span>
			</div>
		</div>
	</div>
	<div class="md:flex-none md:w-28 grid grid-cols-3 md:grid-cols-1 gap-6">
		<div class="md:hidden">
			{{ controller.i18n + '.status.text' | translate }}
		</div>
		<div class="col-span-2 md:justify-self-start justify-self-end">
			<i [class]="task.statusCssIconClass" class="text-xl"></i>
		</div>
	</div>

	<div
		class="md:flex-none w-10 md:flex md:justify-end lg:space-x-3 md:space-x-1"
	>
		<ng-content></ng-content>
	</div>
</ng-container>
